export const Brand = {
  LYKA: 'lyka',
  TYGA: 'tyga',
} as const
export type Brand = typeof Brand[keyof typeof Brand]

export const OrderWorkerTopic = {
  order_created: 'order_created',
  order_paid: 'order_paid',
  order_updated: 'order_updated',
  order_cancelled: 'order_cancelled',
  shipment_created: 'shipment_created',
  fulfilment_status_updated: 'fulfilment_status_updated',
  order_rebalance_requested: 'order_rebalance_requested',
  post_payment_order_modified: 'post_payment_order_modified',
  customer_phoenix_toggled: 'customer_phoenix_toggled',
} as const
export type OrderWorkerTopic = typeof OrderWorkerTopic[keyof typeof OrderWorkerTopic]

export const HistoryTables = {
  FEEDING_PLAN_HISTORY: 'feeding_plan_history',
  SUBSCRIPTION_CANCELLATION: 'subscription_cancellation',
  SUBSCRIPTION_PAUSE: 'subscription_pause',
  SUBSCRIPTION_EXTRAS_CANCELLATION: 'subscription_extras_cancellation',
  DOG_STATUS_HISTORY: 'dog_status_history',
  DOG_STATUS_HISTORY_JUNCTIONS: 'dog_status_history_junctions',
  DOG_DEACTIVATION_REASONS: 'dog_deactivation_reasons',
} as const
export type HistoryTables = typeof HistoryTables[keyof typeof HistoryTables]
